import { connect } from 'react-redux';

import * as Actions from 'store/analytics/actions';
import { GET_PLACE_DETAIL } from 'store/place/actionTypes';

import AnalyticsOverview from './AnalyticsOverview';

const mapStateToProps = (state) => ({
  isLoadingGetInsightOverview: state.analytics.isLoadingGetInsightOverview,
  isLoadingGetRevenueDistributionOverview:
    state.analytics.isLoadingGetRevenueDistributionOverview,
  isLoadingGetRevenueDistributionChart:
    state.analytics.isLoadingGetRevenueDistributionChart,

  insightOverview: state.analytics.insightOverview,
  revenuaDistributionOverview: state.analytics.revenuaDistributionOverview,
  revenuaDistributionChart: state.analytics.revenuaDistributionChart,
  placeDetail: state.Place.placeDetail,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetInsightOverview: (payload) => dispatch(Actions.getInsightOverview(payload)),

  actionGetRevenueDistributionOverview: (payload) => dispatch(
    Actions.getRevenueDistributionOverview(payload),
  ),

  actionGetRevenueDistributionChart: (payload) => dispatch(
    Actions.getRevenueDistributionChart(payload),
  ),

  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsOverview);
